export const SHOW_FEEDBACK_BANNER = "SHOW_FEEDBACK_BANNER";
export const HIDE_FEEDBACK_BANNER = "HIDE_FEEDBACK_BANNER";

export const showFeedbackBanner = (message, variant = "info") => {
  return {
    type: SHOW_FEEDBACK_BANNER,
    payload: {
      show: true,
      message,
      variant,
    },
  };
};

export const hideFeedbackBanner = () => {
  return {
    type: HIDE_FEEDBACK_BANNER,
  };
};
